import { CSSProperties } from 'react';

import { CSS_COLORS } from 'styles';

export function getBaseReactSelectStyle() {
  const style = {
    control: (styles: CSSProperties) => ({
      ...styles,
      borderRadius: '4px',
      borderWidth: '1px',
      borderColor: CSS_COLORS.border,
      fontSize: '1rem',
      width: 250,
      minHeight: 36,
      display: 'inline-flex',
      overflow: 'visible',
      textOverflow: 'ellipsis',
      background: CSS_COLORS.background,
      color: CSS_COLORS.foreground,
    }),

    valueContainer: (styles: CSSProperties) => ({
      ...styles,
      overflow: 'visible',
    }),

    singleValue: (styles: CSSProperties) => ({
      ...styles,
      overflow: 'visible',
      color: CSS_COLORS.foreground,
    }),

    indicatorSeparator: (styles: CSSProperties) => ({
      ...styles,
      display: 'none',
    }),

    dropdownIndicator: (styles: CSSProperties) => ({
      ...styles,
      color: CSS_COLORS.foreground,
      padding: '0',
      marginRight: '8px',
      '&:hover': {
        color: 'blue',
      },
    }),

    menu: (styles: CSSProperties) => ({
      ...styles,
      fontSize: '1rem',
      margin: '0',
      borderRadius: '4px',
      zIndex: '10',
      background: CSS_COLORS.background,
    }),
  };

  return style;
}
